/**
 * Apply filters on the given array of rows and return a set of filtered rows
 * @param {{[filterName: string]: any}} filters
 * @param {string[]} appliedFilterNames
 * @param {any[]} rows
 * @returns {Set<any>}
 */
export function applyFilters(filters, appliedFilterNames, rows) {
  // if no filter is given, return all the rows
  if (!filters) return new Set(rows)

  let rowsSet = new Set(rows)
  for (const filter of appliedFilterNames.map(name => filters[name]).filter(f => f).filter(f => f.isApplied())) {
    rowsSet = rowsSet.intersection(new Set(filter.filterFn(rows)))
  }
  return rowsSet
}

/**
 * @param {{[name: string]: any}} filters
 * @param {string} filterNameToExclude
 * @returns {string[]}
 */
export function getFilterNamesToApply(filters, filterNameToExclude) {
  const filterNames = Object.keys(filters)
  return filterNames.filter(f => f !== filterNameToExclude)
}

export function createFilterObj(filterObjBase) {
  return {
    items: [],
    ...filterObjBase,
    isApplied: function () {
      return this.items.some(item => item.excluded)
    },
    getExclusionDict: function () {
      return Object.fromEntries(this.items.map(item => [item.text, item.excluded]))
    },
    filterFn: function (rows) {
      const dict = this.getExclusionDict()
      return rows.filter(row => !dict?.[row[filterObjBase.filteredPropertyName]])
    },
    isExcluded: function (dict, row) {
      if (!dict) return false
      return !!dict[row]
    },
    isFilterOn: function() {
      return this.items.some(item => item.excluded)
    },
    getFilterItems: function(rows, filters) {
      const displayedSet = new Set(
        applyFilters(filters, getFilterNamesToApply(filters, this.name), rows)
          .values()
          .map(row => row[this.filteredPropertyName])
      )
      const exclusionDict = this.getExclusionDict()
      return Array.from(new Set(rows.map(row => row[this.filteredPropertyName])).values())
        .map(row => ({
          text: row,
          displayed: displayedSet.has(row),
          excluded: this.isExcluded(exclusionDict, row) ?? false,
        }))
    }
  }
}
